export const PROJECT_DETAILS_STANDARD_SPECIFIC_SCHEMA_UUID = "d17bcb2d-e96e-4ca3-9598-d220316a4137";
